import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import payment from "./payment.module";
import feature from "./feature.module.js";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    payment,
    feature
  },
  plugins: [
    createPersistedState({
      paths: ["payment"]
    })
  ]
});
